import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  saveGroup,
} from "../../services/fire";
import Select from "../common/selectcustom";
import dlv from "dlv";
import { useForm } from "react-hook-form";
import moment from "moment";

import { FormInput } from "../common/forminput";
import Input from "../common/inputfunction";

import FontAwesome from "react-fontawesome";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";

const Additem = ({
  button1,
  isOpen,
  header,
  onCancel,
  onconfirm,
  value,
  list,
  edit
}) => {
  let status;
  try {
    const ojb1 = value;
    status = dlv(ojb1, "status", true);
  } catch {}

  let editid;
  let name;
  let id;
  let areaname;
  let gareaid;
  let groupid;
  let groupname;
  try {
    const ojb = list[0];
    editid = dlv(ojb, "_id", "0");
    name = dlv(ojb, "name", "");
    areaname = dlv(ojb, "areaname", "");
    gareaid = dlv(ojb, "areaid", "0");
    groupid = dlv(ojb, "groupid", "0");
    groupname = dlv(ojb, "groupname", "");
  } catch {}
  const PreloadedValues = {
    id: editid,
    item: name,
  };
  const [error, seterror] = useState("");

  const [autoid, setautoid] = useState(0);

  const [disable, setdisable] = useState(false);
  const [areaid, setareaid] = useState(0);
  const [equipmentid, setequipmentid] = useState(0);
 
  const [enabled, setenabled] = useState(true);

  const { register, handleSubmit, setValue ,formState:{errors}} = useForm({
    mode: "onSubmit",
    //  defaultValues: PreloadedValues,
  });

  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });

  useEffect(() => {
    if (list.length > 0) {
      setareaid(gareaid);
      setequipmentid(groupid);
      setautoid(editid);
      //console.log(id)
    } else {
      setareaid(0);
      setequipmentid(0);
      setautoid(0);
      seterror("");
    }
  }, [setValue, list]);

  useEffect(() => {
    setdisable(!status);
  }, [status]);




  const handleAreaChange = (event) => {
    setareaid(event.currentTarget.value);
    if (event.currentTarget.value !== 0) {
      seterror("");
    }
  };

  const handleEquipChange = (event) => {
    setequipmentid(event.currentTarget.value);
    if (event.currentTarget.value !== 0) {
      seterror("");
    }
  };
  const onSubmit = (data) => {
 
    const saveobject = {
      id: autoid,
      groupid: equipmentid,
      disable: disable,
      ...data,
    };
    // console.log(saveobject);
    SaveData(saveobject);
  };

  const SaveData = async (doc) => {
    try {
      const { data: result } = await saveGroup(doc);
      if (result.status === "success") {
        toast.success("บันทึกเสร็จเรียบร้อย");
        onconfirm();
      } else {
        toast.error(result.message);
        seterror(result.message);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleTextchange = () => {
    setdisable(!disable);
  };
  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div>
        <Modal
          isOpen={isOpen}
          toggle={onCancel}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <ModalHeader>
            <FontAwesome name="pencil-square-o"> </FontAwesome> {header}
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-sm-6 col-xs-12">
                <div className="form-group">
                  <FormInput
                    id="item"
                    name="item"
                    type="text"
                    label="กลุ่มอุปกรณ์"
                    placeholder={edit? name:"ชื่อกลุ่มอุปกรณ์"}
                    value={name}
                    // onChange = {e => setValue()}
                    // defaultValue={PreloadedValues.item}
                   register= {register('item',{
                      required: "กรุณาระบุกลุ่มอุปกรณ์",
                      minLength: {
                        value: 2,
                        message: "ระบุอย่างน้อย 2 ตัวอักษร",
                      },maxLength: {
                        value: 1000,
                        message: "Max length is 50",
                      },
                      
                    })}
                    error={errors.item}
                  />
                </div>
              </div>


              <div className="col-sm-4 col-xs-12">
                <Input
                  name="disable"
                  value={disable}
                  label="ยกเลิกใช้งาน"
                  type="checkbox"
                  onChange={handleTextchange}
                  checked={disable}
                  error=""
                />
              </div>
            </div>
          </ModalBody>
          {error && (
            <div className="col-md-12 alert alert-danger"> {error}</div>
          )}

          {list && list.comment && (
            <Button color="danger">{list.comment}</Button>
          )}
          <ModalFooter>
            {enabled && (
              <Button color="primary" onClick={handleSubmit(onSubmit)}>
                {button1}
              </Button>
            )}

            <Button color="secondary" onClick={onCancel}>
              ยกเลิก
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </form>
  );
};

export default Additem;
